<template>
  <div class="news-createor-container">
    <a-form-model
      ref="ruleForm"
      :rules="rules"
      :model="spider"
      layout="horizontal"
      :labelCol="{ span: 6 }"
      :wrapperCol="{ span: 17, offset: 1 }"
    >
      <Card title="基础信息">
        <div class="form-container">
          <a-form-model-item label="站点名称" prop="spiderName">
            <a-input v-model="spider.spiderName" placeholder="请输入站点名称" />
          </a-form-model-item>

          <a-form-model-item label="国 家" prop="countryCode">
            <CountrySelect v-model="spider.countryCode" />
          </a-form-model-item>

          <a-form-model-item label="站点地址" prop="spiderUrls">
            <div>
              <ListInput
                style="flex: 1"
                v-model:value="spider.spiderUrls"
                placeholder="请输入站点地址，按回车键或点击加号添加"
                :data-change="spiderUrlsChange"
              />
              <!-- <Avatar
                v-if="spider.spiderUrls.length > 0"
                style="margin-left: 10px; max-width: 300px"
                :spiderId="$route.query.spiderId"
                :address="spider.spiderUrls[0]"
                :type="$route.query.type"
              /> -->
            </div>
          </a-form-model-item>

          <a-form-model-item label="语 言" prop="langCode">
            <LangSelect v-model="spider.langCode" />
          </a-form-model-item>

          <a-form-model-item label="调度周期时间" prop="spiderExecTimeCycle">
            <a-input-group compact>
              <a-input-number
                :min="1"
                :max="max"
                style="width: calc(100% - 95px)"
                v-model="spider.spiderExecTimeCycle"
              >
              </a-input-number>
              <a-select style="width: 95px" v-model="spider.spiderExecTimeType">
                <a-select-option :value="0"> 秒/次</a-select-option>
                <a-select-option :value="1"> 分/次</a-select-option>
                <a-select-option :value="2"> 时/次</a-select-option>
                <a-select-option :value="3"> 天/次</a-select-option>
                <a-select-option :value="4"> 月/次</a-select-option>
              </a-select>
            </a-input-group>
          </a-form-model-item>

          <a-form-model-item label="爬虫深度" prop="spiderLevel">
            <a-select style="width: 100%" v-model="spider.spiderLevel" placeholder="请选择爬取深度">
              <a-select-option :value="-1"> 全部</a-select-option>
              <a-select-option :value="1"> 1层</a-select-option>
              <a-select-option :value="2"> 2层</a-select-option>
              <a-select-option :value="3"> 3层</a-select-option>
              <a-select-option :value="4"> 4层</a-select-option>
            </a-select>
          </a-form-model-item>

          <a-form-model-item label="服务器部署区域" prop="deployType">
            <a-radio-group v-model="spider.deployType">
              <a-radio :value="0"> 国内</a-radio>
              <a-radio :value="1"> 新加坡</a-radio>
            </a-radio-group>
          </a-form-model-item>

          <a-form-model-item label="标签设置" prop="spiderTags">
            <div class="tags-inner">
              <Tag
                class="a-tag"
                v-for="(tag, index) in spider.spiderTags"
                :onDelete="() => onSelectTag(tag)"
                :key="index"
              >
                <a-tooltip :title="tag.spiderTagName" :delay="1000">
                  {{ tag.spiderTagName }}
                </a-tooltip>
              </Tag>
              <div class="add-tag" @click="isShowTagSelectorModal = true">+ 添加标签</div>
            </div>
          </a-form-model-item>
        </div>
      </Card>

      <Card title="黑白名单配置">
        <div class="form-container">
          <a-form-model-item label="域名(白名单)">
            <TagInput title="域名白名单" v-model="spider.whiteConfig.hosts" />
          </a-form-model-item>

          <a-form-model-item label="域名(黑名单)">
            <TagInput title="域名黑名单" v-model="spider.blackConfig.hosts" />
          </a-form-model-item>

          <a-form-model-item label="路径(白名单)">
            <TagInput title="路径白名单" v-model="spider.whiteConfig.paths" />
          </a-form-model-item>

          <a-form-model-item label="路径(黑名单)">
            <TagInput title="路径黑名单" v-model="spider.blackConfig.paths" />
          </a-form-model-item>
        </div>
      </Card>
      <Card title="高级配置">
        <a-row :gutter="20">
          <a-col :span="8">
            <a-form-model-item label="浏览器">
              <a-radio-group button-style="solid" v-model="spider.browserConfig.enabled">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="20">
          <a-col :span="8">
            <a-form-model-item label="IP代理">
              <a-radio-group button-style="solid" v-model="spider.ipConfig.enabled">
                <a-radio-button :value="0"> 关 </a-radio-button>
                <a-radio-button :value="1"> 开 </a-radio-button>
              </a-radio-group>
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              v-if="spider.ipConfig.enabled == 1"
              label="代理国家"
              :prop="Boolean(spider.ipConfig.enabled) ? 'ipConfigCountry' : ''"
            >
              <CountrySelect v-model="spider.ipConfigCountry" />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item
              v-if="spider.ipConfig.enabled == 1"
              label="代理数量:"
              :prop="Boolean(spider.ipConfig.enabled) ? 'ipConfigNum' : ''"
            >
              <a-input-number
                :min="1"
                v-model="spider.ipConfigNum"
                style="width: 100%"
                placeholder="请输入IP代理数量"
              />
            </a-form-model-item>
          </a-col>
        </a-row>

        <a-row :gutter="20">
          <a-col :span="8">
            <a-form-model-item label="并发数">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.synNum"
                placeholder="并发数:"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="间隔时间(ms)">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.synCycle"
                placeholder="间隔时间(ms):"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="重试次数:">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.retryNum"
                placeholder="重试次数"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="超时时间(s)">
              <a-input-number
                :min="1"
                style="width: 100%"
                v-model="spider.timeOut"
                placeholder="请求超时时间"
              />
            </a-form-model-item>
          </a-col>
          <a-col :span="8">
            <a-form-model-item label="user-agent">
              <a-input v-model="spider.userAgent" placeholder="请输入user-agent" />
            </a-form-model-item>
          </a-col>

          <a-col :span="8">
            <a-form-model-item label="cookie">
              <a-input v-model="spider.cookie" placeholder="请输入cookie" />
            </a-form-model-item>
          </a-col>
        </a-row>

        <div class="header-text">header头配置：</div>
        <a-row :gutter="20" :style="{ marginBottom: '24px' }" class="header-detail">
          <a-col
            :style="{ marginBottom: '12px' }"
            :span="12"
            v-for="(header, index) in spider.headConfig"
          >
            <div class="rule-item">
              <div class="filed">
                <a-input v-model="header.name" placeholder="请输入字段名" />
              </div>
              <div class="input">
                <a-input v-model="header.value" placeholder="请输入值" />
              </div>
              <div class="operate">
                <a-tooltip>
                  <template slot="title">新增</template>
                  <a-icon type="plus-circle" @click="addHeader(index)" />
                </a-tooltip>

                <a-tooltip v-if="spider.headConfig.length > 1">
                  <template slot="title">删除</template>
                  <a-icon type="minus-circle" @click="deleteHeader(index)" />
                </a-tooltip>
              </div>
            </div>
          </a-col>
        </a-row>

        <a-button size="large" class="btn" type="primary" @click="onSubmit">下一步</a-button>
        <a-button
          size="large"
          class="btn"
          style="bottom: 50px"
          type="primary"
          v-if="$route.query.spiderId"
          @click="back()"
          >返回
        </a-button>
      </Card>
    </a-form-model>

    <a-modal
      title="选择标签"
      :visible="isShowTagSelectorModal"
      okText="确定"
      cancelText="取消"
      :closable="false"
      @cancel="isShowTagSelectorModal = false"
      @ok="isShowTagSelectorModal = false"
      :width="725"
    >
      <div class="tags-modal-contianer">
        <div class="tabs-operation">
          <a-button type="primary" icon="plus" @click="handleTagAdd">新增</a-button>
        </div>

        <a-tree
          checkable
          :defaultExpandAll="true"
          :checkStrictly="true"
          :checkedKeys="spider.spiderTags.map((t) => t.spiderTagId)"
          @check="onUpdateCheckedKeys"
        >
          <a-tree-node v-for="item in labels" :key="item.spiderTagId" :value="item.spiderTagId">
            <div class="node-title" slot="title">
              <span @click.stop="handTagCheck(item)">{{ item.title }}</span>
              <a-icon type="edit" class="icon" @click.stop="handTagEdit(item)" />

              <a-popconfirm title="确定要删除吗?" @confirm="() => handTagDelete(item)">
                <a-icon type="delete" class="icon" />
              </a-popconfirm>
            </div>
            <a-tree-node v-for="i in item.children" :key="i.spiderTagId" :value="i.spiderTagId">
              <div class="node-title" slot="title">
                <span @click.stop="handTagCheck(i)">{{ i.title }}</span>
                <a-icon type="edit" class="icon" @click.stop="handTagEdit(i)" />

                <a-popconfirm title="确定要删除吗?" @confirm="() => handTagDelete(i)">
                  <a-icon type="delete" class="icon" />
                </a-popconfirm>
              </div>
            </a-tree-node>
          </a-tree-node>
        </a-tree>
      </div>
    </a-modal>

    <a-drawer
      :title="createAndUpdateData == null ? '新增标签' : '修改标签'"
      width="600"
      :closable="true"
      :visible="createAndUpdateShow"
      @close="createAndUpdateShow = false"
    >
      <TagForm
        v-if="createAndUpdateShow"
        ref="form"
        :formModel="createAndUpdateData"
        :roots="labels"
        @refresh="handleRefresh"
      />
    </a-drawer>
  </div>
</template>

<script>
import ListInput from '@/components/ListInput/'
import LangSelect from '@/components/LangSelect/'
import CountrySelect from '@/components/CountrySelect/'
// import Avatar from '@/components/Avatar/'
import { queryTagListApi } from '@/api/Site/Create'
import { deleteTagApi } from '@/api/System/Tags'

import { onHttpResponseSilent } from '@/utils/request'
import Tag from '../components/Tag'
import Card from '../components/Card'
import TagInput from '../components/TagInput'
import TagForm from '../components/TagForm.vue'

export default {
  components: {
    ListInput,
    // Avatar,
    LangSelect,
    CountrySelect,
    Card,
    Tag,
    TagInput,
    TagForm
  },
  props: ['spider'],
  data() {
    let validateSpiderUrls = (rule, value, callback) => {
      if (value == null || value.length == 0) {
        callback(new Error('站点地址至少填写一个'))
      } else {
        callback()
      }
    }
    return {
      activeKey: [1, 2],
      labelCol: { span: 6 },
      wrapperCol: { span: 18 },
      min: 1,
      rules: {
        spiderName: [{ required: true, message: '站点名称必填', trigger: 'blur' }],
        deployType: [{ required: true, message: '部署方式必填', trigger: 'blur' }],
        countryCode: [{ required: true, message: '国家必填', trigger: 'blur' }],
        spiderLevel: [{ required: true, message: '爬取深度必填', trigger: 'blur' }],
        ipConfigNum: [{ required: true, message: '代理数量必填', trigger: 'blur' }],
        spiderExecTimeCycle: [{ required: true, message: '调度周期时间必填', trigger: 'blur' }],
        ipConfigCountry: [{ required: true, message: '代理国家必填', trigger: 'blur' }],
        spiderUrls: [
          {
            type: 'array',
            required: true,
            validator: validateSpiderUrls,
            trigger: 'change'
          }
        ],
        langCode: [{ required: true, message: '国家必填', trigger: 'blur' }],
        spiderTags: [
          {
            type: 'array',
            required: true,
            message: '标签至少选择一个',
            trigger: 'change'
          }
        ]
      },

      isShowTagSelectorModal: false,
      originLabels: [],
      labels: [],
      isAllShow: false,

      createAndUpdateData: null,
      createAndUpdateShow: false
    }
  },
  computed: {
    max() {
      let { spiderExecTimeType } = this.spider
      if (spiderExecTimeType == 0 || spiderExecTimeType == 1) {
        return 59
      } else if (spiderExecTimeType == 2) {
        return 23
      } else if (spiderExecTimeType == 3) {
        return 31
      } else {
        return 12
      }
    }
  },
  mounted() {
    this.getLabels()
  },
  methods: {
    back() {
      let { type } = this.$route.query
      if (type === 'api') {
        sessionStorage.types = 'others'
      } else {
        sessionStorage.types = 'news'
      }
      this.$router.back(-1)
    },
    spiderUrlsChange(spiderUrls) {
      this.$refs.ruleForm.validateField('spiderUrls')
    },
    onSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          this.$emit('changeActive')
        } else {
          this.$message.error('表单填写不完整，请检查表单')
        }
      })
    },
    getLabels() {
      queryTagListApi({})
        .then(onHttpResponseSilent)
        .then(({ data }) => {
          this.originLabels = [...data]
          data = data.map((d) => ({
            ...d,
            title: d.spiderTagName,
            key: d.spiderTagId
          }))
          this.labels = data
            .filter((d) => d.parentId === -1)
            .map((d) => ({
              ...d,
              children: []
            }))
          data.forEach((d) => {
            const root = this.labels.find((r) => r.spiderTagId === d.parentId)
            if (root) {
              root.children.push(d)
            }
          })
        })
    },

    onSelectTag(tag) {
      if (this.spider.spiderTags.map((t) => t.spiderTagId).includes(tag.spiderTagId)) {
        this.spider.spiderTags = this.spider.spiderTags.filter(
          (t) => t.spiderTagId !== tag.spiderTagId
        )
      } else {
        this.spider.spiderTags.push(tag)
      }
      this.$refs.ruleForm.validateField('spiderTags')
    },

    addHeader(index) {
      this.spider.headConfig.splice(index + 1, 0, {
        name: '',
        value: ''
      })
    },

    deleteHeader(index) {
      this.spider.headConfig.splice(index, 1)
    },

    onUpdateCheckedKeys(tags) {
      const checked = tags.checked
      this.spider.spiderTags = this.originLabels.filter((d) => checked.includes(d.spiderTagId))
    },

    handleRefresh() {
      this.createAndUpdateShow = false
      this.getLabels()
    },

    handleTagAdd() {
      this.createAndUpdateData = null
      this.createAndUpdateShow = true
    },

    // 手动点击文字的时候进行标签选中：
    handTagCheck(val) {
      if (this.spider.spiderTags.map((t) => t.spiderTagId).includes(val.spiderTagId)) {
        this.spider.spiderTags = this.spider.spiderTags.filter(
          (t) => t.spiderTagId !== val.spiderTagId
        )
      } else {
        this.spider.spiderTags.push(val)
      }
    },

    handTagEdit(val) {
      this.createAndUpdateData = { ...val }
      this.createAndUpdateShow = true
    },

    async handTagDelete(val) {
      const res = await deleteTagApi(val.spiderTagId)
      let { code, msg } = res
      if (code === 200) {
        this.getLabels()
      } else {
        this.$message.error(msg)
      }
    }
  }
}
</script>

<style lang="less" scoped>
.news-createor-container {
  /*margin-bottom: 50px;*/

  .form-container {
    width: 100%;
    display: grid;
    grid-template-columns: 45% 45%;
    gap: 0 60px;

    &.tiny {
      grid-template-columns: repeat(auto-fill, 280px);
    }

    .tags-inner {
      display: grid;
      grid-template-columns: repeat(auto-fill, 85px);
      gap: 10px;
      max-height: 180px;
      overflow-y: auto;

      .a-tag:hover {
        background: #3c93ff;
        color: #fff;
      }

      .add-tag {
        width: 100%;
        height: 36px;
        background: #f5f6fa;
        border-radius: 4px;
        color: #3c93ff;
        border: none;
        line-height: 34px;
        text-align: center;
        cursor: pointer;
      }
    }
  }
}

.tags-modal-contianer {
  &::v-deep .ant-tree li .ant-tree-node-content-wrapper:hover {
    background: none;
  }
  &::v-deep .ant-tree li .ant-tree-node-content-wrapper {
    .node-title {
      display: flex;
      align-items: center;

      .icon {
        font-size: 12px;
        margin-left: 8px;
      }
      .icon:hover,
      span:hover {
        color: #1890ff;
      }
    }
  }

  &::v-deep .ant-tree li .ant-tree-node-content-wrapper.ant-tree-node-selected {
    background: none;
  }
}

.btn {
  position: absolute;
  bottom: 0px;
  right: -180px;
  width: 100px;
}
.header-text {
  color: rgba(0, 0, 0, 0.85);
  margin-bottom: 12px;
  padding-left: 14px;
}
.header-detail {
  margin-left: 1px;
}

.rule-item {
  display: flex;
  .operate {
    margin-left: 15px;
    width: 80px;
    display: flex;
    align-items: center;

    i {
      margin-right: 10px;
      font-size: 16px;
      font-weight: 600;
      cursor: pointer;
      color: #1890ff;
    }
  }
  .filed {
    margin-right: 10px;
    width: 120px;
  }
  .input {
    flex: 1;
  }
}
</style>
